// // // // // // import React, { useState, useEffect } from "react";
// // // // // // import {
// // // // // //   TableContainer,
// // // // // //   Table,
// // // // // //   TableHead,
// // // // // //   TableRow,
// // // // // //   TableCell,
// // // // // //   TableBody,
// // // // // //   Paper,
// // // // // //   Card,
// // // // // //   CardContent,
// // // // // //   Box,
// // // // // //   Typography,
// // // // // // } from "@mui/material";

// // // // // // import InputLabel from "@mui/material/InputLabel";
// // // // // // import MenuItem from "@mui/material/MenuItem";
// // // // // // import FormControl from "@mui/material/FormControl";
// // // // // // import Select from "@mui/material/Select";
// // // // // // import TextField from "@mui/material/TextField";

// // // // // // import axiosClient from "../axiosClient";
// // // // // // import { useTranslation } from "react-i18next";

// // // // // // const genderChoices = [
// // // // // //   { label: "Male", value: "M" },
// // // // // //   { label: "Female", value: "F" },
// // // // // // ];

// // // // // // const roleChoices = [
// // // // // //   { label: "Secretary", value: "ADMIN" },
// // // // // //   { label: "Patient", value: "CLIENT" },
// // // // // //   { label: "Doctor", value: "STAFF" },
// // // // // // ];

// // // // // // const Clients = () => {
// // // // // //   const [users, setUsers] = useState([]);
// // // // // //   const [gender, setGender] = useState("");
// // // // // //   const [role, setRole] = useState("");
// // // // // //   const [search, setSearch] = useState("");
// // // // // //   const { t } = useTranslation();

// // // // // //   const getUsers = () => {
// // // // // //     const params = {};

// // // // // //     if (role) {
// // // // // //       params["role"] = role;
// // // // // //     }

// // // // // //     if (gender) {
// // // // // //       params["gender"] = gender;
// // // // // //     }

// // // // // //     if (search) {
// // // // // //       params["search"] = search;
// // // // // //     }

// // // // // //     axiosClient
// // // // // //       .get("api/print_all_users/", { params: params })
// // // // // //       .then((data) => {
// // // // // //         console.log(data.data.custom_users);
// // // // // //         setUsers(data.data.custom_users);
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         console.log(err);
// // // // // //       });
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     getUsers();
// // // // // //     // eslint-disable-next-line
// // // // // //   }, [gender, role, search]);
// // // // // //   return (
// // // // // //     <>
// // // // // //       <Box
// // // // // //         display="flex"
// // // // // //         justifyContent="center"
// // // // // //         alignItems="center"
// // // // // //         height="100%"
// // // // // //         marginTop="16"
// // // // // //       >
// // // // // //         <Card elevation={16}>
// // // // // //           <CardContent>
// // // // // //             <Box
// // // // // //               sx={{
// // // // // //                 display: "flex",
// // // // // //                 justifyContent: "space-between",
// // // // // //                 mb: 5,
// // // // // //                 gap: 2,
// // // // // //                 width: "100%",
// // // // // //               }}
// // // // // //             >
// // // // // //               <Box sx={{ width: "100%" }}>
// // // // // //                 <Typography
// // // // // //                   variant="body1"
// // // // // //                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
// // // // // //                 >
// // // // // //                   {t("Search By")}
// // // // // //                 </Typography>
// // // // // //                 <TextField
// // // // // //                   fullWidth
// // // // // //                   id="search"
// // // // // //                   label={t("Search")}
// // // // // //                   variant="outlined"
// // // // // //                   value={search}
// // // // // //                   onChange={(e) => setSearch(e.target.value)}
// // // // // //                 />
// // // // // //               </Box>
// // // // // //               <Box sx={{ width: "100%" }}>
// // // // // //                 <Typography
// // // // // //                   variant="body1"
// // // // // //                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
// // // // // //                 >
// // // // // //                   {t("Filter By")}
// // // // // //                 </Typography>
// // // // // //                 <Box sx={{ display: "flex", gap: 2 }}>
// // // // // //                   <FormControl fullWidth>
// // // // // //                     <InputLabel id="role-select-label">{t("Role")}</InputLabel>
// // // // // //                     <Select
// // // // // //                       labelId="role-select-label"
// // // // // //                       id="role-select"
// // // // // //                       value={role}
// // // // // //                       label={t("Role")}
// // // // // //                       onChange={(e) => setRole(e.target.value)}
// // // // // //                       sx={{ textAlign: "left" }}
// // // // // //                     >
// // // // // //                       <MenuItem value="">Default</MenuItem>
// // // // // //                       {roleChoices.map((role, idx) => (
// // // // // //                         <MenuItem key={idx} value={role.value}>
// // // // // //                           {t(role.label)}
// // // // // //                         </MenuItem>
// // // // // //                       ))}
// // // // // //                     </Select>
// // // // // //                   </FormControl>
// // // // // //                   <FormControl fullWidth>
// // // // // //                     <InputLabel id="gender-select-label">
// // // // // //                       {t("Gender")}
// // // // // //                     </InputLabel>
// // // // // //                     <Select
// // // // // //                       labelId="gender-select-label"
// // // // // //                       id="gender-select"
// // // // // //                       value={gender}
// // // // // //                       label={t("Gender")}
// // // // // //                       onChange={(e) => setGender(e.target.value)}
// // // // // //                       sx={{ textAlign: "left" }}
// // // // // //                     >
// // // // // //                       <MenuItem value="">Default</MenuItem>
// // // // // //                       {genderChoices.map((gender, idx) => (
// // // // // //                         <MenuItem key={idx} value={gender.value}>
// // // // // //                           {gender.label}
// // // // // //                         </MenuItem>
// // // // // //                       ))}
// // // // // //                     </Select>
// // // // // //                   </FormControl>
// // // // // //                 </Box>
// // // // // //               </Box>
// // // // // //             </Box>

// // // // // //             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // // // //               <Table>
// // // // // //                 <TableHead>
// // // // // //                   <TableRow>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Name")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Surname")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Date of Birth")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Gender")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Email")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Username")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Phone Number")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     {/* <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("GESY NUMBER")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell> */}
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Role")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Assigned Staff")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("User ID")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     {/* <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("ID NUMBER")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell> */}

// // // // // //                     <TableCell>
// // // // // //                       <Typography variant="h7" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
// // // // // //                         {t("Hardcopy Consent")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>

// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Agreed to GDPR Policy?")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("GDPR Policy Agreement Date")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                     <TableCell>
// // // // // //                       <Typography
// // // // // //                         variant="h7"
// // // // // //                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
// // // // // //                       >
// // // // // //                         {t("Recorded IP Address on time of GDPR Policy Agreement")}
// // // // // //                       </Typography>
// // // // // //                     </TableCell>
// // // // // //                   </TableRow>
// // // // // //                 </TableHead>
// // // // // //                 <TableBody>
// // // // // //                   {users.map((row, index) => (
// // // // // //                     <TableRow key={index}>
// // // // // //                       <TableCell>{row.first_name}</TableCell>
// // // // // //                       <TableCell>{row.last_name}</TableCell>
// // // // // //                       <TableCell>{row.date_birth}</TableCell>
// // // // // //                       <TableCell sx={{ whiteSpace: "nowrap" }}>
// // // // // //                         {row.gender === "M"
// // // // // //                           ? "Male"
// // // // // //                           : row.gender === "F"
// // // // // //                             ? "Female"
// // // // // //                             : "Non-declared"}
// // // // // //                       </TableCell>
// // // // // //                       <TableCell>{row.email}</TableCell>
// // // // // //                       <TableCell>{row.username}</TableCell>
// // // // // //                       <TableCell>{row.phone_number}</TableCell>

// // // // // //                       {/* <TableCell>{row.gesy_number}</TableCell> */}

// // // // // //                       <TableCell>
// // // // // //                         {row.user_role === "STAFF"
// // // // // //                           ? t("DOCTOR")
// // // // // //                           : row.user_role === "CLIENT"
// // // // // //                             ? t("PATIENT")
// // // // // //                             : row.user_role === "ADMIN"
// // // // // //                               ? t("SECRETARY")
// // // // // //                               : t(row.user_role)}
// // // // // //                       </TableCell>
// // // // // //                       <TableCell>{row?.assigned_staff?.name}</TableCell>
// // // // // //                       <TableCell>{row.id}</TableCell>
// // // // // //                       {/* <TableCell>{row.id_card || "  "}</TableCell> */}
// // // // // //                       <TableCell>{row.hardcopy_consent ? t("Yes") : t("No")}</TableCell>
// // // // // //                       <TableCell>
// // // // // //                         {row.gdpr_accepted ? "Yes" : "No"}
// // // // // //                       </TableCell>
// // // // // //                       <TableCell>
// // // // // //                         {row.gdpr_accepted
// // // // // //                           ? row.gdpr_agreement_date
// // // // // //                           : "Not Accepted"}
// // // // // //                       </TableCell>
// // // // // //                       <TableCell>
// // // // // //                         {row.gdpr_accepted
// // // // // //                           ? row.gdpr_ip
// // // // // //                           : "Not Accepted"}
// // // // // //                       </TableCell>
// // // // // //                     </TableRow>
// // // // // //                   ))}
// // // // // //                 </TableBody>
// // // // // //               </Table>
// // // // // //             </TableContainer>
// // // // // //           </CardContent>
// // // // // //         </Card>
// // // // // //       </Box>
// // // // // //     </>
// // // // // //   );
// // // // // // };

// // // // // // export default Clients;
// // // // // import React, { useState, useEffect } from "react";
// // // // // import {
// // // // //   TableContainer,
// // // // //   Table,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   TableCell,
// // // // //   TableBody,
// // // // //   Paper,
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Box,
// // // // //   Typography,
// // // // // } from "@mui/material";
// // // // // import InputLabel from "@mui/material/InputLabel";
// // // // // import MenuItem from "@mui/material/MenuItem";
// // // // // import FormControl from "@mui/material/FormControl";
// // // // // import Select from "@mui/material/Select";
// // // // // import TextField from "@mui/material/TextField";

// // // // // import axiosClient from "../axiosClient";
// // // // // import { useTranslation } from "react-i18next";

// // // // // const pickUsersFromResponse = (data) => {
// // // // //   if (!data) return [];
// // // // //   if (Array.isArray(data)) return data;
// // // // //   if (Array.isArray(data?.results)) return data.results;
// // // // //   if (Array.isArray(data?.custom_users)) return data.custom_users;
// // // // //   return [];
// // // // // };

// // // // // const genderChoices = [
// // // // //   { label: "Male", value: "M" },
// // // // //   { label: "Female", value: "F" },
// // // // // ];

// // // // // const roleChoices = [
// // // // //   { label: "Secretary", value: "ADMIN" },
// // // // //   { label: "Patient", value: "CLIENT" },
// // // // //   { label: "Doctor", value: "STAFF" },
// // // // // ];

// // // // // const Clients = () => {
// // // // //   const [users, setUsers] = useState([]);
// // // // //   const [gender, setGender] = useState("");
// // // // //   const [role, setRole] = useState("");
// // // // //   const [search, setSearch] = useState("");
// // // // //   const { t } = useTranslation();

// // // // //   const getUsers = async () => {
// // // // //     const params = {};
// // // // //     if (role) params.role = role;
// // // // //     if (gender) params.gender = gender;
// // // // //     if (search) params.search = search;

// // // // //     try {
// // // // //       // ✅ NEW endpoint
// // // // //       const res = await axiosClient.get("api/users/", { params });
// // // // //       setUsers(pickUsersFromResponse(res.data));
// // // // //     } catch (err) {
// // // // //       console.log(err);
// // // // //     }
// // // // //   };

// // // // //   useEffect(() => {
// // // // //     getUsers();
// // // // //     // eslint-disable-next-line
// // // // //   }, [gender, role, search]);

// // // // //   return (
// // // // //     <Box display="flex" justifyContent="center" alignItems="center" height="100%" marginTop="16px">
// // // // //       <Card elevation={16}>
// // // // //         <CardContent>
// // // // //           <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
// // // // //             <Box sx={{ width: "100%" }}>
// // // // //               <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // // // //                 {t("Search By")}
// // // // //               </Typography>
// // // // //               <TextField
// // // // //                 fullWidth
// // // // //                 id="search"
// // // // //                 label={t("Search")}
// // // // //                 variant="outlined"
// // // // //                 value={search}
// // // // //                 onChange={(e) => setSearch(e.target.value)}
// // // // //               />
// // // // //             </Box>

// // // // //             <Box sx={{ width: "100%" }}>
// // // // //               <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // // // //                 {t("Filter By")}
// // // // //               </Typography>

// // // // //               <Box sx={{ display: "flex", gap: 2 }}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel id="role-select-label">{t("Role")}</InputLabel>
// // // // //                   <Select
// // // // //                     labelId="role-select-label"
// // // // //                     value={role}
// // // // //                     label={t("Role")}
// // // // //                     onChange={(e) => setRole(e.target.value)}
// // // // //                     sx={{ textAlign: "left" }}
// // // // //                   >
// // // // //                     <MenuItem value="">{t("Default")}</MenuItem>
// // // // //                     {roleChoices.map((r, idx) => (
// // // // //                       <MenuItem key={idx} value={r.value}>
// // // // //                         {t(r.label)}
// // // // //                       </MenuItem>
// // // // //                     ))}
// // // // //                   </Select>
// // // // //                 </FormControl>

// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel id="gender-select-label">{t("Gender")}</InputLabel>
// // // // //                   <Select
// // // // //                     labelId="gender-select-label"
// // // // //                     value={gender}
// // // // //                     label={t("Gender")}
// // // // //                     onChange={(e) => setGender(e.target.value)}
// // // // //                     sx={{ textAlign: "left" }}
// // // // //                   >
// // // // //                     <MenuItem value="">{t("Default")}</MenuItem>
// // // // //                     {genderChoices.map((g, idx) => (
// // // // //                       <MenuItem key={idx} value={g.value}>
// // // // //                         {t(g.label)}
// // // // //                       </MenuItem>
// // // // //                     ))}
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Box>
// // // // //             </Box>
// // // // //           </Box>

// // // // //           <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // // //             <Table>
// // // // //               <TableHead>
// // // // //                 <TableRow>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Name")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Surname")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Date of Birth")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Gender")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Email")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Username")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Phone Number")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Role")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("Assigned Staff")}</Typography></TableCell>
// // // // //                   <TableCell><Typography sx={{ fontWeight: "bold" }}>{t("User ID")}</Typography></TableCell>
// // // // //                 </TableRow>
// // // // //               </TableHead>

// // // // //               <TableBody>
// // // // //                 {users.map((row) => (
// // // // //                   <TableRow key={row.id}>
// // // // //                     <TableCell>{row.first_name}</TableCell>
// // // // //                     <TableCell>{row.last_name}</TableCell>
// // // // //                     <TableCell>{row.date_birth}</TableCell>
// // // // //                     <TableCell>
// // // // //                       {row.gender === "M" ? t("Male") : row.gender === "F" ? t("Female") : t("Non-declared")}
// // // // //                     </TableCell>
// // // // //                     <TableCell>{row.email}</TableCell>
// // // // //                     <TableCell>{row.username}</TableCell>
// // // // //                     <TableCell>{row.phone_number}</TableCell>
// // // // //                     <TableCell>
// // // // //                       {row.user_role === "STAFF"
// // // // //                         ? t("DOCTOR")
// // // // //                         : row.user_role === "CLIENT"
// // // // //                         ? t("PATIENT")
// // // // //                         : row.user_role === "ADMIN"
// // // // //                         ? t("SECRETARY")
// // // // //                         : t("Non-declared")}
// // // // //                     </TableCell>
// // // // //                     <TableCell>{row?.assigned_staff?.name || ""}</TableCell>
// // // // //                     <TableCell>{row.id}</TableCell>
// // // // //                   </TableRow>
// // // // //                 ))}
// // // // //               </TableBody>
// // // // //             </Table>
// // // // //           </TableContainer>
// // // // //         </CardContent>
// // // // //       </Card>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default Clients;


// // // // import React, { useState, useEffect } from "react";
// // // // import {
// // // //   TableContainer,
// // // //   Table,
// // // //   TableHead,
// // // //   TableRow,
// // // //   TableCell,
// // // //   TableBody,
// // // //   Paper,
// // // //   Card,
// // // //   CardContent,
// // // //   Box,
// // // //   Typography,
// // // // } from "@mui/material";
// // // // import InputLabel from "@mui/material/InputLabel";
// // // // import MenuItem from "@mui/material/MenuItem";
// // // // import FormControl from "@mui/material/FormControl";
// // // // import Select from "@mui/material/Select";
// // // // import TextField from "@mui/material/TextField";

// // // // import axiosClient from "../axiosClient";
// // // // import { useTranslation } from "react-i18next";

// // // // const pickUsersFromResponse = (data) => {
// // // //   if (!data) return [];
// // // //   if (Array.isArray(data)) return data;
// // // //   if (Array.isArray(data?.results)) return data.results;
// // // //   if (Array.isArray(data?.custom_users)) return data.custom_users;
// // // //   return [];
// // // // };

// // // // const genderChoices = [
// // // //   { label: "Male", value: "M" },
// // // //   { label: "Female", value: "F" },
// // // // ];

// // // // // ✅ UPDATED ROLES: Matches the current Technician/Admin structure
// // // // const roleChoices = [
// // // //   { label: "Secretary", value: "ADMIN" },
// // // //   { label: "Technician", value: "TECHNICIAN" },
// // // // ];

// // // // const Clients = () => {
// // // //   const [users, setUsers] = useState([]);
// // // //   const [gender, setGender] = useState("");
// // // //   const [role, setRole] = useState("");
// // // //   const [search, setSearch] = useState("");
// // // //   const { t } = useTranslation();

// // // //   const getUsers = async () => {
// // // //     const params = {};
// // // //     if (role) params.user_role = role; // Backend usually uses user_role
// // // //     if (gender) params.gender = gender;
// // // //     if (search) params.search = search;

// // // //     try {
// // // //       // ✅ Using the auth/users endpoint which we verified earlier
// // // //       const res = await axiosClient.get("auth/users/", { params });
// // // //       setUsers(pickUsersFromResponse(res.data));
// // // //     } catch (err) {
// // // //       console.error("Error fetching users:", err);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     getUsers();
// // // //     // eslint-disable-next-line
// // // //   }, [gender, role, search]);

// // // //   return (
// // // //     <Box display="flex" justifyContent="center" alignItems="center" height="100%" marginTop="16px">
// // // //       <Card elevation={16} sx={{ width: "98%", borderRadius: 2 }}>
// // // //         <CardContent>
// // // //           <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", textAlign: "left" }}>
// // // //             {t("User Management List")}
// // // //           </Typography>

// // // //           <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%" }}>
// // // //             <Box sx={{ width: "100%" }}>
// // // //               <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // // //                 {t("Search By Name/Email")}
// // // //               </Typography>
// // // //               <TextField
// // // //                 fullWidth
// // // //                 id="search"
// // // //                 label={t("Search")}
// // // //                 variant="outlined"
// // // //                 value={search}
// // // //                 onChange={(e) => setSearch(e.target.value)}
// // // //               />
// // // //             </Box>

// // // //             <Box sx={{ width: "100%" }}>
// // // //               <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // // //                 {t("Filter By")}
// // // //               </Typography>

// // // //               <Box sx={{ display: "flex", gap: 2 }}>
// // // //                 <FormControl fullWidth>
// // // //                   <InputLabel id="role-select-label">{t("Role")}</InputLabel>
// // // //                   <Select
// // // //                     labelId="role-select-label"
// // // //                     value={role}
// // // //                     label={t("Role")}
// // // //                     onChange={(e) => setRole(e.target.value)}
// // // //                     sx={{ textAlign: "left" }}
// // // //                   >
// // // //                     <MenuItem value="">{t("All Roles")}</MenuItem>
// // // //                     {roleChoices.map((r, idx) => (
// // // //                       <MenuItem key={idx} value={r.value}>
// // // //                         {t(r.label)}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                 </FormControl>

// // // //                 <FormControl fullWidth>
// // // //                   <InputLabel id="gender-select-label">{t("Gender")}</InputLabel>
// // // //                   <Select
// // // //                     labelId="gender-select-label"
// // // //                     value={gender}
// // // //                     label={t("Gender")}
// // // //                     onChange={(e) => setGender(e.target.value)}
// // // //                     sx={{ textAlign: "left" }}
// // // //                   >
// // // //                     <MenuItem value="">{t("All")}</MenuItem>
// // // //                     {genderChoices.map((g, idx) => (
// // // //                       <MenuItem key={idx} value={g.value}>
// // // //                         {t(g.label)}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                 </FormControl>
// // // //               </Box>
// // // //             </Box>
// // // //           </Box>

// // // //           <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // //             <Table stickyHeader>
// // // //               <TableHead>
// // // //                 <TableRow>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Full Name")}</TableCell>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Email")}</TableCell>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Phone Number")}</TableCell>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Role")}</TableCell>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("City")}</TableCell>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("ID Card")}</TableCell>
// // // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("User ID")}</TableCell>
// // // //                 </TableRow>
// // // //               </TableHead>

// // // //               <TableBody>
// // // //                 {users.map((row) => (
// // // //                   <TableRow key={row.id} hover>
// // // //                     <TableCell>{`${row.first_name} ${row.last_name}`}</TableCell>
// // // //                     <TableCell>{row.email}</TableCell>
// // // //                     <TableCell>{row.phone_number}</TableCell>
// // // //                     <TableCell>
// // // //                       {/* ✅ UPDATED ROLE DISPLAY */}
// // // //                       {row.user_role === "TECHNICIAN"
// // // //                         ? t("TECHNICIAN")
// // // //                         : row.user_role === "ADMIN"
// // // //                         ? t("SECRETARY")
// // // //                         : row.user_role}
// // // //                     </TableCell>
// // // //                     <TableCell>{row.city || "-"}</TableCell>
// // // //                     <TableCell>{row.id_card || "-"}</TableCell>
// // // //                     <TableCell>{row.id}</TableCell>
// // // //                   </TableRow>
// // // //                 ))}
// // // //               </TableBody>
// // // //             </Table>
// // // //           </TableContainer>
// // // //         </CardContent>
// // // //       </Card>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default Clients;



// // // import React, { useState, useEffect } from "react";
// // // import {
// // //   TableContainer,
// // //   Table,
// // //   TableHead,
// // //   TableRow,
// // //   TableCell,
// // //   TableBody,
// // //   Paper,
// // //   Card,
// // //   CardContent,
// // //   Box,
// // //   Typography,
// // //   Button,
// // // } from "@mui/material";
// // // import InputLabel from "@mui/material/InputLabel";
// // // import MenuItem from "@mui/material/MenuItem";
// // // import FormControl from "@mui/material/FormControl";
// // // import Select from "@mui/material/Select";
// // // import TextField from "@mui/material/TextField";

// // // import axiosClient from "../axiosClient";
// // // import { useTranslation } from "react-i18next";

// // // const pickUsersFromResponse = (data) => {
// // //   if (!data) return [];
// // //   if (Array.isArray(data)) return data;
// // //   if (Array.isArray(data?.results)) return data.results;
// // //   if (Array.isArray(data?.custom_users)) return data.custom_users;
// // //   return [];
// // // };

// // // const genderChoices = [
// // //   { label: "Male", value: "M" },
// // //   { label: "Female", value: "F" },
// // // ];

// // // const roleChoices = [
// // //   { label: "Secretary", value: "ADMIN" },
// // //   { label: "Technician", value: "TECHNICIAN" },
// // // ];

// // // const Clients = () => {
// // //   const [users, setUsers] = useState([]);
// // //   const [gender, setGender] = useState("");
// // //   const [role, setRole] = useState("");
// // //   const [search, setSearch] = useState("");
// // //   const { t } = useTranslation();

// // //   // ✅ Updated logic to fetch users
// // //   const getUsers = async () => {
// // //     const params = {};
// // //     // Django filters usually expect these specific keys
// // //     if (role) params.user_role = role; 
// // //     if (gender) params.gender = gender;
// // //     if (search) params.search = search; // This maps to your backend SearchFilter

// // //     try {
// // //       const res = await axiosClient.get("auth/users/", { params });
// // //       setUsers(pickUsersFromResponse(res.data));
// // //     } catch (err) {
// // //       console.error("Search Error:", err);
// // //     }
// // //   };

// // //   // Run on initial load
// // //   useEffect(() => {
// // //     getUsers();
// // //   }, []);

// // //   // ✅ Manual trigger for the search button
// // //   const handleSearchSubmit = (e) => {
// // //     if (e) e.preventDefault();
// // //     getUsers();
// // //   };

// // //   return (
// // //     <Box display="flex" justifyContent="center" alignItems="center" height="100%" marginTop="16px">
// // //       <Card elevation={16} sx={{ width: "98%", borderRadius: 2 }}>
// // //         <CardContent>
// // //           <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", textAlign: "left" }}>
// // //             {t("User Management List")}
// // //           </Typography>

// // //           {/* ✅ Added a form wrapper to handle 'Enter' key searches */}
// // //           <form onSubmit={handleSearchSubmit}>
// // //             <Box sx={{ display: "flex", justifyContent: "space-between", mb: 5, gap: 2, width: "100%", alignItems: "flex-end" }}>
// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Search By Name/Email")}
// // //                 </Typography>
// // //                 <TextField
// // //                   fullWidth
// // //                   id="search"
// // //                   label={t("Search")}
// // //                   variant="outlined"
// // //                   value={search}
// // //                   onChange={(e) => setSearch(e.target.value)}
// // //                 />
// // //               </Box>

// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Filter By Role")}
// // //                 </Typography>
// // //                 <FormControl fullWidth>
// // //                   <InputLabel id="role-select-label">{t("Role")}</InputLabel>
// // //                   <Select
// // //                     labelId="role-select-label"
// // //                     value={role}
// // //                     label={t("Role")}
// // //                     onChange={(e) => setRole(e.target.value)}
// // //                   >
// // //                     <MenuItem value="">{t("All Roles")}</MenuItem>
// // //                     {roleChoices.map((r, idx) => (
// // //                       <MenuItem key={idx} value={r.value}>{t(r.label)}</MenuItem>
// // //                     ))}
// // //                   </Select>
// // //                 </FormControl>
// // //               </Box>

// // //               <Box sx={{ width: "100%" }}>
// // //                 <Typography variant="body1" sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}>
// // //                   {t("Gender")}
// // //                 </Typography>
// // //                 <FormControl fullWidth>
// // //                   <InputLabel id="gender-select-label">{t("Gender")}</InputLabel>
// // //                   <Select
// // //                     labelId="gender-select-label"
// // //                     value={gender}
// // //                     label={t("Gender")}
// // //                     onChange={(e) => setGender(e.target.value)}
// // //                   >
// // //                     <MenuItem value="">{t("All")}</MenuItem>
// // //                     {genderChoices.map((g, idx) => (
// // //                       <MenuItem key={idx} value={g.value}>{t(g.label)}</MenuItem>
// // //                     ))}
// // //                   </Select>
// // //                 </FormControl>
// // //               </Box>

// // //               {/* ✅ The missing Search Button */}
// // //               <Button 
// // //                 variant="contained" 
// // //                 size="large" 
// // //                 onClick={handleSearchSubmit}
// // //                 sx={{ height: "56px", px: 4 }}
// // //               >
// // //                 {t("SEARCH")}
// // //               </Button>
// // //             </Box>
// // //           </form>

// // //           <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // //             <Table stickyHeader>
// // //               <TableHead>
// // //                 <TableRow>
// // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Full Name")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Email")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Phone")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("Role")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("City")}</TableCell>
// // //                   <TableCell sx={{ fontWeight: "bold", bgcolor: "primary.main", color: "white" }}>{t("User ID")}</TableCell>
// // //                 </TableRow>
// // //               </TableHead>

// // //               <TableBody>
// // //                 {users.length > 0 ? (
// // //                   users.map((row) => (
// // //                     <TableRow key={row.id} hover>
// // //                       <TableCell>{`${row.first_name} ${row.last_name}`}</TableCell>
// // //                       <TableCell>{row.email}</TableCell>
// // //                       <TableCell>{row.phone_number}</TableCell>
// // //                       <TableCell>
// // //                         {row.user_role === "TECHNICIAN" ? t("TECHNICIAN") : t("SECRETARY")}
// // //                       </TableCell>
// // //                       <TableCell>{row.city || "-"}</TableCell>
// // //                       <TableCell>{row.id}</TableCell>
// // //                     </TableRow>
// // //                   ))
// // //                 ) : (
// // //                   <TableRow>
// // //                     <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
// // //                       {t("No users found matching your search.")}
// // //                     </TableCell>
// // //                   </TableRow>
// // //                 )}
// // //               </TableBody>
// // //             </Table>
// // //           </TableContainer>
// // //         </CardContent>
// // //       </Card>
// // //     </Box>
// // //   );
// // // };

// // // export default Clients;

// // import React, { useState, useEffect } from "react";
// // import {
// //   TableContainer, Table, TableHead, TableRow, TableCell,
// //   TableBody, Paper, Card, CardContent, Box, Typography,
// //   Button, TextField, FormControl, InputLabel, Select, MenuItem
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const pickUsersFromResponse = (data) => {
// //   if (!data) return [];
// //   // If data is the array itself
// //   if (Array.isArray(data)) return data;
// //   // If data is paginated (results key)
// //   if (data.results && Array.isArray(data.results)) return data.results;
// //   // Other possible keys
// //   if (data.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
// //   if (data.users && Array.isArray(data.users)) return data.users;
// //   return [];
// // };

// // const Clients = () => {
// //   const [users, setUsers] = useState([]);
// //   const [gender, setGender] = useState("");
// //   const [role, setRole] = useState("");
// //   const [search, setSearch] = useState("");
// //   const { t } = useTranslation();

// //   const getUsers = async () => {
// //     // Constructing parameters to match Django Backend expectations
// //     const params = {};
    
// //     if (search.trim()) {
// //       params.search = search.trim(); // Standard Django SearchFilter key
// //     }
    
// //     if (role) {
// //       params.user_role = role; // Try field 1
// //       params.role = role;      // Try field 2 (fallback)
// //     }
    
// //     if (gender) {
// //       params.gender = gender;
// //     }

// //     try {
// //       console.log("Fetching with params:", params);
// //       const res = await axiosClient.get("auth/users/", { params });
// //       const data = pickUsersFromResponse(res.data);
// //       setUsers(data);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //     }
// //   };

// //   // Initial load
// //   useEffect(() => {
// //     getUsers();
// //   }, []);

// //   const handleSearchClick = () => {
// //     getUsers();
// //   };

// //   const handleReset = () => {
// //     setSearch("");
// //     setRole("");
// //     setGender("");
// //     // We use a timeout to ensure state is updated before fetching
// //     setTimeout(() => getUsers(), 100);
// //   };

// //   return (
// //     <Box sx={{ p: 2 }}>
// //       <Card elevation={16} sx={{ borderRadius: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" fontWeight="bold" gutterBottom>
// //             {t("User Management")}
// //           </Typography>

// //           {/* Filters Row */}
          
// //           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, alignItems: "flex-end" }}>
// //             <TextField
// //               label={t("Search Name/Email")}
// //               variant="outlined"
// //               value={search}
// //               onChange={(e) => setSearch(e.target.value)}
// //               sx={{ flex: 1, minWidth: "200px" }}
// //               onKeyPress={(e) => e.key === 'Enter' && getUsers()}
// //             />

// //             <FormControl sx={{ minWidth: "150px" }}>
// //               <InputLabel>{t("Role")}</InputLabel>
// //               <Select
// //                 value={role}
// //                 label={t("Role")}
// //                 onChange={(e) => setRole(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All Roles")}</MenuItem>
// //                 <MenuItem value="ADMIN">{t("Secretary (Admin)")}</MenuItem>
// //                 <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <FormControl sx={{ minWidth: "150px" }}>
// //               <InputLabel>{t("Gender")}</InputLabel>
// //               <Select
// //                 value={gender}
// //                 label={t("Gender")}
// //                 onChange={(e) => setGender(e.target.value)}
// //               >
// //                 <MenuItem value="">{t("All")}</MenuItem>
// //                 <MenuItem value="M">{t("Male")}</MenuItem>
// //                 <MenuItem value="F">{t("Female")}</MenuItem>
// //               </Select>
// //             </FormControl>

// //             <Button variant="contained" size="large" onClick={handleSearchClick} sx={{ height: "56px" }}>
// //               {t("Search")}
// //             </Button>
            
// //             <Button variant="outlined" size="large" onClick={handleReset} sx={{ height: "56px" }}>
// //               {t("Clear")}
// //             </Button>
// //           </Box>

// //           <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
// //             <Table stickyHeader>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell sx={{ fontWeight: "bold" }}>{t("Full Name")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold" }}>{t("Email")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold" }}>{t("Role")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold" }}>{t("Phone")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold" }}>{t("City")}</TableCell>
// //                   <TableCell sx={{ fontWeight: "bold" }}>{t("ID")}</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {users.length > 0 ? (
// //                   users.map((u) => (
// //                     <TableRow key={u.id} hover>
// //                       <TableCell>{`${u.first_name} ${u.last_name}`}</TableCell>
// //                       <TableCell>{u.email}</TableCell>
// //                       <TableCell>{u.user_role}</TableCell>
// //                       <TableCell>{u.phone_number}</TableCell>
// //                       <TableCell>{u.city || "-"}</TableCell>
// //                       <TableCell>{u.id}</TableCell>
// //                     </TableRow>
// //                   ))
// //                 ) : (
// //                   <TableRow>
// //                     <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
// //                       {t("No users found")}
// //                     </TableCell>
// //                   </TableRow>
// //                 )}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default Clients;


// import React, { useState, useEffect, useMemo } from "react";
// import {
//   TableContainer, Table, TableHead, TableRow, TableCell,
//   TableBody, Paper, Card, CardContent, Box, Typography,
//   Button, TextField, FormControl, InputLabel, Select, MenuItem,
//   CircularProgress, Alert
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const pickUsersFromResponse = (data) => {
//   if (!data) return [];
//   if (Array.isArray(data)) return data;
//   if (data.results && Array.isArray(data.results)) return data.results;
//   if (data.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
//   return [];
// };

// const Clients = () => {
//   const [allUsers, setAllUsers] = useState([]); // Master list
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("");
//   const [search, setSearch] = useState("");
//   const { t } = useTranslation();

//   // 1. Fetch data from backend
//   const fetchUsers = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       // We fetch the full list initially
//       const res = await axiosClient.get("auth/users/");
//       const data = pickUsersFromResponse(res.data);
//       setAllUsers(data);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setError(t("Could not connect to the server. Please check your connection."));
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   // 2. FRONTEND FILTER LOGIC (This works even if the Backend filter is broken)
//   const filteredUsers = useMemo(() => {
//     return allUsers.filter((user) => {
//       const matchesRole = role ? user.user_role === role : true;
//       const matchesGender = gender ? user.gender === gender : true;
      
//       const searchStr = search.toLowerCase();
//       const matchesSearch = search
//         ? (user.first_name?.toLowerCase().includes(searchStr) ||
//            user.last_name?.toLowerCase().includes(searchStr) ||
//            user.email?.toLowerCase().includes(searchStr) ||
//            user.phone_number?.includes(searchStr))
//         : true;

//       return matchesRole && matchesGender && matchesSearch;
//     });
//   }, [allUsers, role, gender, search]);

//   const handleReset = () => {
//     setSearch("");
//     setRole("");
//     setGender("");
//   };

//   return (
//     <Box sx={{ p: { xs: 1, sm: 3 } }}>
//       <Card elevation={16} sx={{ borderRadius: 2 }}>
//         <CardContent>
//           <Typography variant="h5" fontWeight="bold" gutterBottom>
//             {t("User Management System")}
//           </Typography>

//           {/* Filters Row */}
          
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2 }}>
//             <TextField
//               label={t("Search Name, Email or Phone")}
//               variant="outlined"
//               size="small"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               sx={{ flex: { xs: "1 1 100%", sm: "1 1 300px" } }}
//             />

//             <FormControl size="small" sx={{ minWidth: "150px", flex: 1 }}>
//               <InputLabel>{t("Role")}</InputLabel>
//               <Select
//                 value={role}
//                 label={t("Role")}
//                 onChange={(e) => setRole(e.target.value)}
//               >
//                 <MenuItem value="">{t("All Roles")}</MenuItem>
//                 <MenuItem value="ADMIN">{t("Secretary (Admin)")}</MenuItem>
//                 <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: "150px", flex: 1 }}>
//               <InputLabel>{t("Gender")}</InputLabel>
//               <Select
//                 value={gender}
//                 label={t("Gender")}
//                 onChange={(e) => setGender(e.target.value)}
//               >
//                 <MenuItem value="">{t("All")}</MenuItem>
//                 <MenuItem value="M">{t("Male")}</MenuItem>
//                 <MenuItem value="F">{t("Female")}</MenuItem>
//               </Select>
//             </FormControl>

//             <Button 
//                 variant="outlined" 
//                 color="secondary" 
//                 onClick={handleReset}
//                 sx={{ minWidth: "100px" }}
//             >
//               {t("Reset")}
//             </Button>
            
//             <Button 
//                 variant="contained" 
//                 onClick={fetchUsers}
//                 disabled={loading}
//             >
//               {t("Refresh List")}
//             </Button>
//           </Box>

//           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

//           <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <Table stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Full Name")}</TableCell>
//                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Email")}</TableCell>
//                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Role")}</TableCell>
//                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Phone")}</TableCell>
//                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("City")}</TableCell>
//                     <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {filteredUsers.length > 0 ? (
//                     filteredUsers.map((u) => (
//                       <TableRow key={u.id} hover>
//                         <TableCell>{`${u.first_name || ""} ${u.last_name || ""}`}</TableCell>
//                         <TableCell>{u.email}</TableCell>
//                         <TableCell>
//                             <Typography variant="body2" sx={{ 
//                                 color: u.user_role === 'ADMIN' ? 'primary.main' : 'secondary.main',
//                                 fontWeight: 'bold'
//                             }}>
//                                 {u.user_role}
//                             </Typography>
//                         </TableCell>
//                         <TableCell>{u.phone_number}</TableCell>
//                         <TableCell>{u.city || "-"}</TableCell>
//                         <TableCell>{u.id}</TableCell>
//                       </TableRow>
//                     ))
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
//                         <Typography color="textSecondary">{t("No users found matching your criteria")}</Typography>
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             )}
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default Clients;

import React, { useState, useEffect, useMemo } from "react";
import {
  TableContainer, Table, TableHead, TableRow, TableCell,
  TableBody, Paper, Card, CardContent, Box, Typography,
  Button, TextField, FormControl, InputLabel, Select, MenuItem,
  CircularProgress, Alert
} from "@mui/material";
import axiosClient from "../axiosClient";
import { useTranslation } from "react-i18next";

const pickUsersFromResponse = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (data.results && Array.isArray(data.results)) return data.results;
  if (data.custom_users && Array.isArray(data.custom_users)) return data.custom_users;
  return [];
};

const Clients = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [role, setRole] = useState("");
  const [search, setSearch] = useState("");
  const { t } = useTranslation();

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosClient.get("auth/users/");
      const data = pickUsersFromResponse(res.data);
      setAllUsers(data);
    } catch (err) {
      console.error("Fetch error:", err);
      setError(t("Could not connect to the server."));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Filter logic updated to remove gender dependency
  const filteredUsers = useMemo(() => {
    return allUsers.filter((user) => {
      const matchesRole = role ? user.user_role === role : true;
      
      const searchStr = search.toLowerCase();
      const matchesSearch = search
        ? (user.first_name?.toLowerCase().includes(searchStr) ||
           user.last_name?.toLowerCase().includes(searchStr) ||
           user.email?.toLowerCase().includes(searchStr) ||
           user.phone_number?.includes(searchStr))
        : true;

      return matchesRole && matchesSearch;
    });
  }, [allUsers, role, search]);

  const handleReset = () => {
    setSearch("");
    setRole("");
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 3 } }}>
      <Card elevation={16} sx={{ borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {t("User Management System")}
          </Typography>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 4, mt: 2, alignItems: "center" }}>
            <TextField
              label={t("Search Name, Email or Phone")}
              variant="outlined"
              size="small"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{ flex: { xs: "1 1 100%", sm: "1 1 400px" } }}
            />

            <FormControl size="small" sx={{ minWidth: "200px" }}>
              <InputLabel>{t("Role")}</InputLabel>
              <Select
                value={role}
                label={t("Role")}
                onChange={(e) => setRole(e.target.value)}
              >
                <MenuItem value="">{t("All Roles")}</MenuItem>
                {/* <MenuItem value="ADMIN">{t("Secretary (Admin)")}</MenuItem> */}
                <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
              </Select>
            </FormControl>

            <Button 
                variant="outlined" 
                color="secondary" 
                onClick={handleReset}
                sx={{ height: "40px" }}
            >
              {t("Reset")}
            </Button>
            
            <Button 
                variant="contained" 
                onClick={fetchUsers}
                disabled={loading}
                sx={{ height: "40px" }}
            >
              {t("Refresh")}
            </Button>
          </Box>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <TableContainer component={Paper} sx={{ maxHeight: 600, border: "1px solid #e0e0e0" }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Full Name")}</TableCell>
                    <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Email")}</TableCell>
                    <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Role")}</TableCell>
                    <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("Phone")}</TableCell>
                    <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("City")}</TableCell>
                    <TableCell sx={{ fontWeight: "bold", bgcolor: "#f5f5f5" }}>{t("ID")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredUsers.length > 0 ? (
                    filteredUsers.map((u) => (
                      <TableRow key={u.id} hover>
                        <TableCell>{`${u.first_name || ""} ${u.last_name || ""}`}</TableCell>
                        <TableCell>{u.email}</TableCell>
                        <TableCell>
                            <Typography variant="body2" sx={{ 
                                color: u.user_role === 'ADMIN' ? 'primary.main' : 'secondary.main',
                                fontWeight: 'bold'
                            }}>
                                {u.user_role}
                            </Typography>
                        </TableCell>
                        <TableCell>{u.phone_number}</TableCell>
                        <TableCell>{u.city || "-"}</TableCell>
                        <TableCell>{u.id}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
                        <Typography color="textSecondary">{t("No users found")}</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Clients;